import { createRedux } from 'src/firebase';
import { Member } from 'src/store';

const {
  actions,
  actionTypes,
  collectionReducer: membersReducer,
  docReducer: memberDetailReducer,
} = createRedux<Member>('members');

export {
  actions,
  actionTypes,
  membersReducer,
  memberDetailReducer,
};



// WEBPACK FOOTER //
// ./src/members/redux.ts